import { configureClient } from '@platform/client';

import { accessToken } from './auth/client';
import { env } from './env';

/**
 * The admin is a client like any other: it reaches the API through the generated
 * SDK, never with `fetch`. That is the payoff for having built the SDK — a second
 * consumer costs a base URL and nothing else, and gets the same types, the same
 * correlation id per request, and the same typed errors as the mobile app.
 *
 * The token getter is a function rather than a value so this app never hands the SDK
 * a token that has since been refreshed, and so `packages/client` never learns which
 * auth vendor is behind it. It returns null when signed out, which means no
 * Authorization header — exactly right for the public routes.
 */
configureClient({ baseUrl: env.VITE_API_URL, getToken: accessToken });
